import React from 'react'
import Grid from '@blocks/Grid'
import { Box } from '@styles/helpers'
import { Ring } from '@blocks/Loading'
import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import ArchiveEmpty from './components/ArchiveEmpty'

export default function Archive<T extends ObjectWithId>({ data, component: Component, pagination, options }: ArchiveProps<T>) {
    if (!data) return <Ring />
        
    if (!data.length) 
        return <ArchiveEmpty empty={options?.empty} />
        
    return (
        <Box narrow hide={!options?.box}>
            <Grid id="top" gap="20px">
                <ArchivePagination pagination={pagination} />
                <Grid gap={options?.grid?.gap} columns={options?.grid?.columns}>
                    {data.map((item, idx) => <Component key={item.id} data={item} idx={findIdx(idx, options, pagination)} />)}
                </Grid>
                <ArchivePagination pagination={pagination} scroll={true} />
            </Grid>
        </Box>
    )
}

const ArchivePagination = ({ pagination, scroll }: ArchivePaginationProps) => {
    if (!pagination || !pagination.enabled)
        return null

    const handleNavigation = (fn: () => void) => {
        if (scroll) {
            const top = document.getElementById('top')
            window.scrollTo({ top: top!.offsetTop - 20, behavior: "smooth" })    
        }
        
        fn()
    }

    return (
        <Flex justifyContent="flex-end" gap="5px" alignItems="center">
            <Button disabled={!pagination.canPrev} onClick={() => handleNavigation(pagination.prev)} type="tertiary">Prev</Button>
            <small>{pagination.firstElementOnPage} - {pagination.lastElementOnPage} from {pagination.elements} {pagination.label}</small>
            <Button disabled={!pagination.canNext} onClick={() => handleNavigation(pagination.next)} type="tertiary">Next</Button>
        </Flex>
    )
}

function findIdx(idx: number, options: ArchiveProps<any>["options"], pagination: ArchiveProps<any>["pagination"]) {
    if (!options?.idx) return 0
    if (!pagination) return idx
    return (pagination.firstElementOnPage - 1) + idx
}